import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button, type ButtonProps } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";
import { writeClipboard } from "@/lib/clipboard";

export function CopyButton({
  text,
  label,
  className,
  variant = "ghost",
  size = "icon-sm",
}: {
  text: string;
  label?: string;
  className?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
}) {
  const [copied, setCopied] = useState(false);
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const ok = await writeClipboard(text);
    if (ok) {
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1400);
    } else {
      toast.error("Couldn't copy — select the text and copy manually");
    }
  };
  return (
    <Button
      variant={variant}
      size={label ? (size === "icon-sm" ? "sm" : size) : size}
      onClick={copy}
      className={cn(copied && "text-primary", className)}
      title="Copy"
    >
      {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
      {label && <span>{copied ? "Copied" : label}</span>}
    </Button>
  );
}
